import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { MessageService, ConfirmationService } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { DocSummaryGenerationSelectDialogComponent } from './doc-summary-generation-select-dialog/doc-summary-generation-select-dialog.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { StyleClassModule } from 'primeng/styleclass';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { LoaderComponent } from './loader/loader.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileuploadMetadataDialogComponent } from './fileupload-metadata-dialog/fileupload-metadata-dialog.component';
import { CodeDialogComponent } from './code-dialog/code-dialog.component';
import { ExcelTablesInfoComponent } from './excel-tables-info/excel-tables-info.component';
import { CarouselModule } from 'primeng/carousel';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';
import { AvailableForDirective } from '@app/directives/available-for.directive';
import { ChartsComponent } from '@app/modules/chat/pages/chat/components/chat-main/charts/charts.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { CustomInstructionsDialogComponent } from './custom-instructions-dialog/custom-instructions-dialog.component';
import { DocumentSummaryDialogComponent } from './document-summary-dialog/document-summary-dialog.component';
import { DocumentSummarySidebarComponent } from './document-summary-sidebar/document-summary-sidebar.component';
import { TableSummarySidebarComponent } from './table-summary-sidebar/table-summary-sidebar.component';
import { HighlightDirective } from '../directives/highlight.directive';
import { RatingModule } from 'primeng/rating';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PlotlyModule } from 'angular-plotly.js';
import * as PlotlyJS from 'plotly.js-dist-min';
import { ChartVisualizerComponent } from './chart-visualizer/chart-visualizer.component';

PlotlyModule.plotlyjs = PlotlyJS;


@NgModule({
    declarations: [
        ConfirmationDialogComponent,
        DocSummaryGenerationSelectDialogComponent,
        FeedbackDialogComponent,
        LoaderComponent,
        FileuploadMetadataDialogComponent,
        CodeDialogComponent,
        ExcelTablesInfoComponent,
        AvailableForDirective,
        ChartsComponent,
        CustomInstructionsDialogComponent,
        DocumentSummaryDialogComponent,
        DocumentSummarySidebarComponent,
        TableSummarySidebarComponent,
        HighlightDirective,
        ChartVisualizerComponent,
    ],
    imports: [
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts'),
        }),
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MARKED_OPTIONS,
                useValue: {
                    breaks: true,
                },
            },
        }),

        CommonModule,
        ConfirmDialogModule,
        CarouselModule,
        DropdownModule,
        MultiSelectModule,
        InputTextModule,
        ButtonModule,
        TooltipModule,
        ToastModule,
        SidebarModule,
        RadioButtonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        StyleClassModule,
        DynamicDialogModule,
        InputNumberModule,
        RatingModule,
        PlotlyModule,
        SelectButtonModule
    ],
    exports: [
        ConfirmationDialogComponent,
        ExcelTablesInfoComponent,
        DocumentSummaryDialogComponent,
        DocumentSummarySidebarComponent,
        TableSummarySidebarComponent,
        DocSummaryGenerationSelectDialogComponent,
        FeedbackDialogComponent,
        LoaderComponent,
        FileuploadMetadataDialogComponent,
        CodeDialogComponent,
        AvailableForDirective,
        ChartsComponent,
        CustomInstructionsDialogComponent,
        HighlightDirective,
        ChartVisualizerComponent,
    ],
    providers: [MessageService, ConfirmationService],
})
export class SharedModule {}
